import { _ as __read } from '../../../_tslib-7a01aab4.js';

var parseQuery = function (queryString) {
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    return pairs.reduce(function (query, item) {
        var _a = __read(item.split('='), 2), key = _a[0], value = _a[1];
        query[decodeURIComponent(key).toLowerCase()] = decodeURIComponent(value || '');
        return query;
    }, {});
};

export { parseQuery };
